var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E84142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2024 33.5508H12.5465C11.5681 33.5508 11.0848 33.5508 10.7902 33.3623C10.4719 33.1558 10.2774 32.8139 10.2539 32.4365C10.2362 32.0888 10.4778 31.6641 10.9611 30.8151L22.4571 10.5439C22.9463 9.68308 23.1938 9.25268 23.5061 9.0935C23.8421 8.92253 24.2428 8.92253 24.5788 9.0935C24.8911 9.25268 25.1387 9.68308 25.6278 10.5439L27.9911 14.671L28.0032 14.6921C28.5315 15.6155 28.7994 16.0838 28.9164 16.5753C29.0461 17.114 29.0461 17.6757 28.9164 18.2144C28.7986 18.7096 28.5333 19.1813 27.997 20.1188L21.9585 30.7974L21.9428 30.8248C21.411 31.7559 21.1415 32.2278 20.768 32.5838C20.3613 32.973 19.8721 33.2558 19.3358 33.4153C18.8466 33.5508 18.2986 33.5508 17.2024 33.5508ZM28.96 33.5508H35.6314C36.6156 33.5508 37.1108 33.5508 37.4056 33.3565C37.7238 33.1501 37.9241 32.802 37.942 32.425C37.9589 32.0884 37.7225 31.6803 37.2593 30.8807C37.2433 30.8534 37.2274 30.8257 37.2111 30.7976L33.8693 25.0786L33.8313 25.0142C33.3617 24.2198 33.1247 23.8186 32.8202 23.6636C32.6551 23.5793 32.4723 23.5353 32.2869 23.5353C32.1015 23.5353 31.9187 23.5793 31.7536 23.6636C31.4471 23.8228 31.1996 24.2414 30.7104 25.0845L27.3806 30.8035L27.3691 30.8231C26.8817 31.6649 26.6381 32.0856 26.6557 32.4307C26.6792 32.8081 26.8737 33.1558 27.1919 33.3623C27.4808 33.5508 27.9758 33.5508 28.96 33.5508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.b9adc022cf6c4e3e4064026f6680b860.svg";
export { ForwardRef as ReactComponent };